import { useToasts } from "app/common/hooks";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";

import { useCrmEnrichmentJobRenameMutation } from "app/pages/sales-intelligence/modules/crm-enrichment/query/mutations/useCrmEnrichmentJobRenameMutation";
import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";
import { salesforceEnrichmentQueryKeys } from "../key-factory";

export default function useSfEnrichmentJobRenameMutation() {
    const { showSuccessToast } = useToasts();

    return useCrmEnrichmentJobRenameMutation({
        apiService: sfEnrichmentApiService,
        queryKeys: salesforceEnrichmentQueryKeys,
        onSuccessCallback() {
            showSuccessToast(
                getToastItemComponent({
                    text: translate("si.crm-enrichment.sf.name-modal.success.rename"),
                }),
            );
        },
    });
}
